const googleHosts = new Set([
  "google.com",
  "www.google.com",
  "maps.google.com",
  "www.maps.google.com",
]);

const buildGoogleEmbedUrl = (query: string) =>
  `https://www.google.com/maps?q=${encodeURIComponent(query)}&output=embed`;

const buildGoogleOpenUrl = (query: string) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;

const normalizeGoogleQuery = (value: string) =>
  value
    .replace(/\+/g, " ")
    .replace(/\/+/g, " ")
    .trim();

export function getMapUrls(value?: string) {
  if (!value?.trim()) {
    return { embedUrl: "", openUrl: "" };
  }

  const raw = value.trim();

  try {
    const url = new URL(raw);
    const host = url.hostname.toLowerCase();

    if (url.pathname.includes("/maps/embed")) {
      return { embedUrl: raw, openUrl: raw };
    }

    if (googleHosts.has(host) || host.endsWith(".google.com")) {
      const q =
        url.searchParams.get("q") ||
        url.searchParams.get("query") ||
        url.searchParams.get("destination");

      if (q) {
        return {
          embedUrl: buildGoogleEmbedUrl(q),
          openUrl: buildGoogleOpenUrl(q),
        };
      }

      const placeMatch = url.pathname.match(/\/(?:maps\/)?place\/([^/]+)/i);
      if (placeMatch?.[1]) {
        const query = normalizeGoogleQuery(decodeURIComponent(placeMatch[1]));
        return {
          embedUrl: buildGoogleEmbedUrl(query),
          openUrl: buildGoogleOpenUrl(query),
        };
      }

      const searchMatch = url.pathname.match(/\/(?:maps\/)?search\/([^/]+)/i);
      if (searchMatch?.[1]) {
        const query = normalizeGoogleQuery(decodeURIComponent(searchMatch[1]));
        return {
          embedUrl: buildGoogleEmbedUrl(query),
          openUrl: buildGoogleOpenUrl(query),
        };
      }
    }

    return { embedUrl: raw, openUrl: raw };
  } catch {
    return {
      embedUrl: buildGoogleEmbedUrl(raw),
      openUrl: buildGoogleOpenUrl(raw),
    };
  }
}
